// extracted by mini-css-extract-plugin
module.exports = {"preWrapper":"styles_preWrapper__1WwhK"};